import React, { Component } from 'react';
import { Select, Input, Divider, Row, Checkbox, Button, message, Tag, InputNumber } from 'antd';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { schema_to_field, showErrorInNotification } from '../../../lib/util';
import Title from 'antd/lib/typography/Title';
import Form from '../../../lib/ui/form';
import ScheduleChanger from '../../../components/schedule_changer';

import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';

import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/tomorrow_night_blue';
import NetworkSelect from '../../../lib/ui/network_select';



const extensions_list = [
  // {text:"",value:""}
]
class BatcherRuleAddEdit extends Component {
  constructor(props) {
    super(props)

    this.state = {
      form_data: this.props.edit_data || {},
      edit_id: this.props.edit_id,
      fetchers: {},
      fetcherSchema: []
    };



    this.list_fetchers = RESTExecutor.list().config({
      label: 'batchers',
      params: {
        pagination: false
      }
    }).callbacks((success) => {
      let fetchers = {};
      success.result.rows.map((item) => {
        fetchers[item.id] = item
      });
      this.setState({
        fetchers: fetchers
      });

      if (this.props.edit_id) {
        this.setState({
          fetcherSchema: schema_to_field(fetchers[this.props.edit_data.batcher_id].validation_config || {})
        })
      }

    })
      .connect(props.domains.settings);


    this.post_fetcher_config = RESTExecutor.post().config({
      label: 'batcher_rule_list'
    }).callbacks((success) => {
      message.success("Rule Added Successfully");
      typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()

    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.batchergroup);

    this.patch_fetcher_config = RESTExecutor.patch().config({
      label: 'batcher_rule_detail',
      // params: {
      //   source_id: this.props.source_id,
      //   config_id: this.props.edit_id
      // }
    }).callbacks((success) => {
      message.success("Rule Modified Successfully");
      typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()


    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.batchergroup);

  };

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    // console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }

  handlePostPatch = () => {
    if (this.state.edit_id) {
      this.patch_fetcher_config.forId(this.state.edit_id).execute({...this.state.form_data,batcher_group_id:this.props.batcher_group_id})
    } else {
      this.post_fetcher_config.execute({...this.state.form_data,batcher_group_id:this.props.batcher_group_id})
    }
  }

  scheduleUpdater = ({ key, value }) => {
    let form_data = this.state.form_data;
    if (!form_data.schedule) {
      form_data.schedule = {}
    }
    form_data.schedule[key] = value;
    this.setState({
      form_data: form_data
    })
  }





  render() {
    const { fetchers, form_data, edit_id, source_id } = this.state;
    let schedule = form_data.schedule || {};

    // console.log("days list",day_list)
    return (
      <div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
        }}>
          <Row type='flex' justify='center' style={{
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              width: 'fit-content',
              textAlign: 'right',
              justifyContent: 'center'
            }}
            >
              <span>
                Rule Name: &nbsp; <Input
                  placeholder={"Rule  Name"}
                  onChange={(e) => {
                    this.stateUpdater({ stateKey: 'form_data', valueKey: 'name', value: e.target.value })
                  }}
                  value={form_data.name}
                  style={{
                    width: 300
                  }} >
                </Input>
              </span>
              <br />
              <span>
                Service: &nbsp;  <NetworkSelect
                  value={form_data.data_service_id}
                  style={{}}
                  item={{ name: "Service",width:300}}
                  url={`/batcher-groups/${this.props.batcher_group_id}/services`}
                  onChange={(received_value) => {
                    this.stateUpdater({
                      stateKey: 'form_data',
                      valueKey: 'data_service_id',
                      value: received_value,
                    })
                    // this._change(item.index, received_value, d_key)
                  }}
                />
              </span>
              <br />
              <span>Batcher: <Select style={{ width: 300 }}
                placeholder="Batcher"
                filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                showSearch
                value={form_data.batcher_id}
                onChange={(value) => {
                  this.stateUpdater({
                    stateKey: 'form_data', valueKey: 'batcher_id', value: value, callback: () => {
                      this.stateUpdater({ stateKey: 'form_data', valueKey: 'batcher_params', value: {} })
                    }
                  });
                  this.setState({
                    fetcherSchema: schema_to_field(fetchers[value].validation_config || {})
                  })
                }}


              >
                {
                  Object.keys(fetchers).map((key, index) => {
                    let item = fetchers[key];
                    return <Select.Option value={item.id} key={item.id}>
                      {item.name}
                    </Select.Option>
                  })
                }

              </Select>
              </span>
            </div>
          </Row>
          <br></br>
          {this.state.fetcherSchema.length > 0 ?
            <React.Fragment>
              <Divider style={{
                marginTop: 8,
                marginBottom: 8
              }} />

              <Title style={{ margin: 0 }} level={4} type='secondary'>Params</Title>
              <Form
                hideTitle
                forCreate={true}
                initialData={form_data.batcher_params || {}}
                submitted={this.state.submitted}
                onChange={(data) => {
                  console.log("Changes", data);
                  this.stateUpdater({
                    stateKey: 'form_data',
                    valueKey: 'batcher_params',
                    value: data,
                  });
                }}
                fields={this.state.fetcherSchema}
                submitting={{}}
                errorMessage={{}}
                validationErrors={{}}
              />
            </React.Fragment>
            : null}






          <Row style={{ marginTop: 12 }} type='flex' justify='space-between'>
            <div>
              <Button type='link' style={{ color: 'red' }} onClick={() => {
                typeof this.props.onClose === 'function' && this.props.onClose()
              }}>Cancel</Button>
            </div>
            <div>
              <Button
                type='primary'
                loading={this.post_fetcher_config.response().fetching || this.patch_fetcher_config.response().fetching}
                disabled={this.post_fetcher_config.response().fetching || this.patch_fetcher_config.response().fetching}
                onClick={() => {
                  this.handlePostPatch()
                }}>Submit</Button>
            </div>
          </Row>


        </div>

      </div>
    );
  }

  componentDidMount() {
    this.list_fetchers.execute()
  }


  componentDidUpdate = (prevProps) => {
    if (this.props.edit_id !== prevProps.edit_id || this.props.edit_data !== prevProps.edit_data) {
      this.list_fetchers.execute()
      this.setState({
        edit_id: this.props.edit_id,
        form_data: this.props.edit_data
      })
    };

  }

}

export default withDomains(BatcherRuleAddEdit, "settings", "batchergroup");
